import {
    AfterViewInit,
    Component,
    ElementRef,
    HostListener,
    OnInit,
    ViewChild,
} from '@angular/core'
import { BreadcrumbService } from '../../shared-components/breadcrumb.service'
import { ActivatedRoute, Router } from '@angular/router'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { UserService } from '../../../../api/services/user.service'
import { CareFinityValidators } from '../../../validators/CareFinityValidators'
import { MessageService, LazyLoadEvent } from 'primeng/api'
import { validateAllFormFields } from '../../../../formUtils'
import { DataPageOfPatient } from '../../../../api/models/data-page-of-patient'
import { Patient, PatientDefaultPage } from '../../../../api/models'
import { PatientService } from '../../../../api/services'
import { DatePipe } from '@angular/common'
import { AppComponent } from 'src/app/app.component'
import { environment } from 'src/environments/environment'
import { NgxSpinnerService } from 'ngx-spinner'
import { Table } from 'primeng/table'
import { SelectedPatientService } from './patient-service'
import { CareFinitySession } from '../../../services/CareFinitySession'

@Component({
    templateUrl: './patient-list.component.html',
    styleUrls: ['./patient-list.component.css'],
})
export class PatientListComponent implements OnInit {

    @ViewChild('tableWrapper') tableWrapper!: ElementRef<HTMLElement>;


    @ViewChild('ptlisttable') dt: Table
    patients: DataPageOfPatient
    selectedPatient: Patient
    showRecords: boolean = false
    rows: number
    DateFormat: any
    lastName: string
    firstName: string
    dOB: Date
    mRN: string
    yearRangeForDatePicker: string
    loading: boolean

    dateFormat: string = 'MM/dd/yyyy'
    //
    // Inside your component class
    searchButtonDisabled: boolean = true // Initially disabled

    private cols: { field: string; header: string; hidden: boolean }[]
    pageSize: number = 0;

    isPNearExpiry?: boolean = false;
    pNearExpirMessage?: string = '';
    isViewedMessage?: boolean = false;
    ispExpireViewedCount: number = 0;

    // lastName: string = '';

    constructor(
        private router: Router,
        private messageService: MessageService,
        private breadcrumbService: BreadcrumbService,
        private route: ActivatedRoute,
        private patientService: PatientService,
        private datePipe: DatePipe,
        private _spinnerService: NgxSpinnerService,
        private selectedPatientService: SelectedPatientService,
    ) {
        this.breadcrumbService.setItems([{ label: '' }])
    }

    ngOnInit() {

        const pExpireViewedCount = Number(localStorage.getItem('PExpireViewedCount')) || 0;
        const isPNearExpiry = localStorage.getItem('IsPNearExpiry') === 'true';

        if (pExpireViewedCount === 0 && isPNearExpiry) {
            this.isViewedMessage = true;
            this.isPNearExpiry = true;
            this.pNearExpirMessage = localStorage.getItem('PNearExpirMessage') || '';
        }
        this.pageSize = CareFinitySession?.applicationSettings?.apiDataPageSize;
        this.cols = [
            { field: 'mrn', header: 'MRN', hidden: false },
            { field: 'fullName', header: 'Name', hidden: false },
            { field: 'ssn', header: 'SSN', hidden: false },
            { field: 'shortDOB', header: 'DOB', hidden: false },
            { field: 'gender', header: 'Gender', hidden: false },
            { field: 'address', header: 'Address', hidden: false },
            { field: 'state', header: 'State', hidden: false },
            // { field: 'patientId', header: 'patientId', hidden: true },
            // { field: 'personId', header: 'personID', hidden: true },
        ]

        this.yearRangeForDatePicker = environment.yearRangeForDatePicker
    }

    @HostListener('document:keydown.enter', ['$event'])
    handleEnterKey(event: KeyboardEvent) {
        const target = event.target as HTMLInputElement
        if (
            (target && target.id === 'lastName') ||
            (target && target.id === 'firstName') ||
            (target && target.id === 'mrn')
        ) {
            this.getpatientList(1, 'fullName', 'Asc')
        }
    }
    /**
     *  This method fetch the list of patients  as  per given parameters
     *  Parameters Outer::[pageNumber :: Sort column ::  Sort order]
     *  Parameters Inner::[emrpracticeId:: lastName ::  firstName :: dob ::mrn :: SortByColumn::SortByDirection]
     *  ReturnType      ::[DataPageOfPatient]
     */
    getpatientList(
        pageNumber: number,
        sortcolumn: string,
        sortorder: string,
    ): void {
        if (sortcolumn == '' && sortorder == '') {
            sortcolumn = 'fullName'
            sortorder = 'Asc'
        }

        this.patientService
            .patientSearch({
                emrpracticeId: localStorage.getItem('EmrPracticeId'),
                pageNumber: pageNumber,
                lastName: this.lastName,
                firstName: this.firstName,
                dob: this.datePipe.transform(this.dOB, this.dateFormat),
                mrn: this.mRN,
                SortByColumn: sortcolumn,
                SortByDirection: sortorder,
            })
            .subscribe(
                (respPatient) => {
                    // console.log(respPatient);
                    this.patients = respPatient;

                        if (this.patients?.totalRecords === 1) {

                            const patient = this.patients.data?.[0];

                            // Extra safety check if fullName or patientId is empty
                            if (!patient.fullName || !patient.patientId) {
                                console.warn('Patient info is missing');
                                return;   // or show a message
                            }

                            sessionStorage.setItem('ptName', patient.fullName);
                            sessionStorage.setItem('ptId', patient.patientId.toString());

                            this.getPatientDetails(patient);
                        }
                       

                    






                    if (this.patients.totalRecords > 0) {
                        this.showRecords = true
                    } else {
                        this.showRecords = false
                    }
                    this.rows = this.patients.pageSize
                    this.loading = false
                },
                (err) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: err?.error,
                        life: 3000,
                    })
                },
            )
    }

    nextPage($event: LazyLoadEvent) {
        this.loading = true
        let pageIndex = $event.first / $event.rows + 1 // Index of the new page if event.page not defined.
        var order = 'Asc'
        if ($event.sortOrder == -1) {
            order = 'Desc'
        }
        this.getpatientList(pageIndex, $event.sortField, order)
    }

    clearpatientList(): void {
        this.lastName = ''
        this.firstName = ''
        this.dOB = null
        this.mRN = ''
        this.showRecords = false

        this.patients = null
    }

    getPatientDetails(patient: Patient) {
        sessionStorage.setItem('ptName', patient['fullName'])
        sessionStorage.setItem('ptId', patient['patientId'])

        this.patientService
            .patientGetPatientDetails({
                personId: patient.patientId,
                practiceId: localStorage.getItem('EmrPracticeId'),
            })
            .subscribe((p) => {
                this.selectedPatientService.changePatient({
                    ...patient,
                    isPatientArchived: p.isPatientArchived,
                })

                if (PatientDefaultPage.Timeline == CareFinitySession.practiceSettings.patientDefaultPage) {
                    this.router.navigate(['Patient/timeline']);


                }
                else {
                    this.router.navigate(['Patient/dashboard'])
                }
            })
    }

    clearFilter() {
        this.firstName = null
        this.lastName = null
        this.mRN = null
        this.dOB = null
        this.patients = null
        this.searchButtonDisabled = true
    }

    checkSearchButtonState() {
        if (this.lastName || this.firstName || this.mRN || this.dOB) {
            this.searchButtonDisabled = false
        } else {
            this.searchButtonDisabled = true
        }
    }

    goToChangePassword(): void {
        // Increment the password expiry viewed count
        let PExpireViewedCount = Number(localStorage.getItem('PExpireViewedCount')) || 0;
        PExpireViewedCount++;
        localStorage.setItem('PExpireViewedCount', PExpireViewedCount.toString());
        this.isViewedMessage = false;
        // Navigate to the change password page
        this.router.navigate(['settings/change-password']);
    }


    ackOK(): void {
        // Retrieve and increment the password expiry viewed count
        const PExpireViewedCount = Number(localStorage.getItem('PExpireViewedCount')) || 0;
        const updatedCount = PExpireViewedCount + 1;

        // Update the value in localStorage
        localStorage.setItem('PExpireViewedCount', updatedCount.toString());

        // Set the viewed message flag
        this.isViewedMessage = false;
    }


    onDialogClose() {
        const PExpireViewedCount = Number(localStorage.getItem('PExpireViewedCount')) || 0;
        const updatedCount = PExpireViewedCount + 1;

        // Update the value in localStorage
        localStorage.setItem('PExpireViewedCount', updatedCount.toString());

        // Set the viewed message flag
        this.isViewedMessage = false;
    }


    onEnterKey() {
        if (this.patients?.totalRecords !== 1) return;

        const patient = this.selectedPatient || this.patients.data[0];
        if (!patient?.patientId) return;

        sessionStorage.setItem('ptName', patient.fullName ?? '');
        sessionStorage.setItem('ptId', patient.patientId.toString());
        this.patientService
            .patientGetPatientDetails({
                personId: patient.patientId,
                practiceId: localStorage.getItem('EmrPracticeId'),
            })
            .subscribe((p) => {
                this.selectedPatientService.changePatient({
                    ...patient,
                    isPatientArchived: p.isPatientArchived,
                })

                if (PatientDefaultPage.Timeline == CareFinitySession.practiceSettings.patientDefaultPage) {
                    this.router.navigate(['Patient/timeline']);


                }
                else {
                    this.router.navigate(['Patient/dashboard'])
                }
            })
    }

    // Optional: allow Enter globally
    @HostListener('window:keydown.enter', ['$event'])
    handleEnter(event: KeyboardEvent) {
        // Only trigger when tableWrapper is focused
        if (document.activeElement === this.tableWrapper?.nativeElement) {
            this.onEnterKey();
        }
    }

}
